export class RequiredSessionError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'RequiredSessionError'
  }
}
